import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Step from 'book-calculator/components/Step';
import PrintingFieldset from 'book-calculator/containers/PrintingFieldset';

const PrintingStep = ({ step }) => (
    <Step
        step={step}
        title={<FormattedMessage id="steps.printing.heading" />}
        description={renderDescription()}
    >
        <PrintingFieldset />
    </Step>
);

function renderDescription() {
    return (
        <div>
            <div className="paragraph">
                <FormattedMessage id="steps.printing.description_1" />
            </div>
            <div className="paragraph">
                <FormattedMessage id="steps.printing.description_2" />
            </div>
        </div>
    );
}

PrintingStep.propTypes = {
    step: PropTypes.number.isRequired,
};

export default PrintingStep;
